import { accessTypeEnum } from './../../lib/enum';

const addAccessRight = [
  accessTypeEnum.admin,
  accessTypeEnum.handlingWashingVehicleTypes
];

export default addAccessRight;
